import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import CertificationGroupsCard from './CertificationGroupsCard';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Toggle from 'react-toggle';
import Select from 'react-select';
import getLocale from '../../../i18n/getLocale';

class CertificationsEditTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: false,
      certification_groups: [],
      types_applicability: [],
      types_list: [],
      aircraft_models_list: [],
      certification_types_list: [],
      training_certification_types_list: [],
      certifications_list: [],
      id: this.props.certification_id,
      name: this.props.certification_data.name,
      aircraft_model_id: this.props.certification_data.aircraft_model_id,
      certification_type_id: this.props.certification_data.certification_type_id,
      training_certification_type_id: this.props.certification_data.training_certification_type_id,
      name_to_group: '',
      certification_id_to_group: '',
      validate_month_time: '',
      certification_ids_to_agroup: '',
      type_to_group: '',
      type_applicability: '',
      expire: this.props.certification_data.expire,
      expire_type: this.props.certification_data.expire_type,
      hours: this.props.certification_data.hours_str,
      result: this.props.certification_data.result,
      offshore: this.props.certification_data.offshore,
      jungle: this.props.certification_data.jungle,
      night_landings: this.props.certification_data.night_landings,
    };

    //bind específico
    this.edit = this.edit.bind(this);
    this.addGroup = this.addGroup.bind(this);
    this.deleteCertificationGroup = this.deleteCertificationGroup.bind(this);

    
    // Handlers

    this.locale = getLocale();
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleSelectChangeMulti(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  
  // LM
  componentWillReceiveProps(newProps) {
    if(typeof this.state.name === 'undefined' && typeof newProps.certification_data.name !== 'undefined') {
      this.setState({
        id: newProps.certification_id,
        name: newProps.certification_data.name,
        aircraft_model_id: newProps.certification_data.aircraft_model_id,
        certification_type_id: newProps.certification_data.certification_type_id,
        training_certification_type_id: newProps.certification_data.training_certification_type_id,
        expire: newProps.certification_data.expire,
        expire_type: newProps.certification_data.expire_type,
        hours: newProps.certification_data.hours_str,
        result: newProps.certification_data.result,
        offshore: newProps.certification_data.offshore,
        jungle: newProps.certification_data.jungle,
        night_landings: newProps.certification_data.night_landings,
      });
    }
    if(Array.isArray(newProps.types_list)) {
      this.setState({types_list: newProps.types_list});
    }
    if(Array.isArray(newProps.types_applicability)) {
      this.setState({types_applicability: newProps.types_applicability});
    }
    if(Array.isArray(newProps.aircraft_models_list)) {
      this.setState({aircraft_models_list: newProps.aircraft_models_list});
    }
    if(Array.isArray(newProps.certification_types_list)) {
      this.setState({certification_types_list: newProps.certification_types_list});
    }
    if(Array.isArray(newProps.training_certification_types_list)) {
      this.setState({training_certification_types_list: newProps.training_certification_types_list});
    }
    if(Array.isArray(newProps.certifications_list)) {
      this.setState({certifications_list: newProps.certifications_list});
    }
    if(Array.isArray(newProps.certification_groups)) {
      this.setState({certification_groups: newProps.certification_groups});
    }
  }
  
  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    var self = this;
    if(!(this.state.training_certification_type_id)){
        self.props.handleAlert(this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.mensagemSelecioneDestinado, 'error', 'open');
    } else if(!(this.state.certification_type_id)){
        self.props.handleAlert(this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.mensagemSelecioneTipo, 'error', 'open');
    } else if(!(this.state.name)){
        self.props.handleAlert(this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.mensagemSelecioneNome, 'error', 'open');
    } else {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        id: this.state.id,
        name: this.state.name,
        aircraft_model_id: this.state.aircraft_model_id,
        certification_type_id: this.state.certification_type_id,
        training_certification_type_id: this.state.training_certification_type_id,
        expire: this.state.expire,
        expire_type: this.state.expire_type,
        hours: this.state.hours,
        result: this.state.result,
        offshore: this.state.offshore,
        jungle: this.state.jungle,
        night_landings: this.state.night_landings,
      };
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/certificado', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  addGroup(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      name_to_group: this.state.name_to_group,
      type_to_group: this.state.type_to_group,
      type_applicability: this.state.type_applicability,
      certification_id_to_group: this.state.certification_id_to_group,
      validate_month_time: this.state.validate_month_time,
      certification_id: this.state.id,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/certificado/grupo', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var dados_temp = self.state.certification_groups;
          dados_temp.push(responseJson.data);
          self.setState({certification_groups: dados_temp});
        }
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  deleteCertificationGroup (event) {
    var certification_group_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.deletar);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/certificado/grupo/' + certification_group_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deleteRow(certification_group_id);
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }
  
  deleteRow(certification_group_id) {
    var certification_groups = this.state.certification_groups;
    certification_groups.map(function(dado, index){
      if (dado.group_id == certification_group_id) {
        certification_groups.splice(index, 1);
      }
    });
    this.setState({certification_groups: certification_groups});
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <div> 
    <form onSubmit={this.edit}>
      <div className="form-group">
        <label>{this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formulario.Nome}:</label>
        <input type="text" name="name" className="form-control" placeholder={this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formulario.placeholder.RegistroDeCertificado} value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
      </div>
      <div className="form-group">
        <label>{this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formulario.TipoDeVencimento}:</label>
        <Select
          className="form-field-name"
          name="expire_type"
          value={this.state.expire_type}
          searchable={true}
          placeholder={this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formulario.placeholder.TipoDeVencimento}
          onChange={this.handleSelectChange.bind(this, 'expire_type')}
          options={[
            {value: "day_format", label: this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formulario.opcoesVencimento.VencimentoPorDia},
            {value: "month_year_format", label: this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formulario.opcoesVencimento.VencimentoPorMes},
          ]}
        />
      </div>
      <div className="form-group">
        <label>{this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formulario.Modelo}:</label>
        <Select
          className="form-field-name"
          name="aircraft_model_id"
          value={this.state.aircraft_model_id}
          searchable={true}
          placeholder={this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formulario.placeholder.SelecionarModeloDeAeronave}
          onChange={this.handleSelectChange.bind(this, 'aircraft_model_id')}
          options={this.state.aircraft_models_list}
        />
      </div>
      <div className="form-group">
        <label>{this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formulario.Tipo}:</label>
        <Select
          className="form-field-name"
          name="certification_type_id"
          value={this.state.certification_type_id}
          searchable={true}
          placeholder={this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formulario.placeholder.SelecionarTipo}
          onChange={this.handleSelectChange.bind(this, 'certification_type_id')}
          options={this.state.certification_types_list}
        />
      </div>
      <div className="form-group">
        <label>{this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formulario.DestinadoA}:</label>
        <Select
          className="form-field-name"
          name="training_certification_type_id"
          value={this.state.training_certification_type_id}
          searchable={true}
          placeholder={this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formulario.placeholder.SelecionarTipo}
          onChange={this.handleSelectChange.bind(this, 'training_certification_type_id')}
          options={this.state.training_certification_types_list}
        />
      </div>
      <div className="form-group">
        <label>{this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formulario.NotaMinima}:</label>
          <InputMask value={this.state.result}  maskChar={null} name="result" mask="99" className="form-control" onChange={this.handleChange.bind(this, 'result')} placeholder={this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formulario.placeholder.NotaMinimaParaValidacaoDoCertificado} />
      </div>
      <div className="form-group">
        <label>{this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formulario.Validade}:</label>
          <InputMask value={this.state.expire}  maskChar={null} name="expire" mask="99" className="form-control" onChange={this.handleChange.bind(this, 'expire')} placeholder={this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formulario.placeholder.ValidadeEmMesesDoCertificado} />
      </div>
      <div className="form-group">
        <label>{this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formulario.CargaHoraria}:</label>
          <InputMask value={this.state.hours}  maskChar={null} name="hours" className="form-control" onChange={this.handleChange.bind(this, 'hours')} placeholder={this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formulario.placeholder.CargaHorariaDoCertificado} />
      </div>
      <div className="form-group">
        <label>{this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formulario.ContaExperienciaOffShore}:</label>
        <br/>
          <Toggle
            checked={this.state.offshore}
            aria-label='No label tag'
            name="offshore"
            onChange={this.handleToggleChange.bind(this, 'offshore')} />
      </div>
      <div className="form-group">
        <label>{this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formulario.ContaExperienciaSelva}:</label>
        <br/>
          <Toggle
            checked={this.state.jungle}
            aria-label='No label tag'
            name="jungle"
            onChange={this.handleToggleChange.bind(this, 'jungle')} />
      </div>
      <div className="form-group">
        <label>{this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formulario.ExperienciaNoturna}:</label>
        <br/>
          <Toggle
            checked={this.state.night_landings}
            aria-label='No label tag'
            name="night_landings"
            onChange={this.handleToggleChange.bind(this, 'night_landings')} />
      </div>
      <div className="form-group">
        <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formulario.botaoSalvarEdicao}</button>
      </div>
    </form>
  </div>
  <hr/>
  <div>
    <h4>{this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.adicionarGrupoDeCertificados}</h4>
    <hr/>
    <p>{this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.paragrafoRelacionarQuaisCertificadosSaoNecessarios}</p>
    <div className="panel panel-default">
      <div className="panel-heading">{this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.adicionarNovoGrupo}</div>
      <div className="panel-body">
        <form onSubmit={this.addGroup}> 
          <div className="form-group">
            <label>{this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formularioAdicionarNovoGrupo.Nome}:</label>
            <input type="text" name="name_to_group" className="form-control" placeholder={this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formularioAdicionarNovoGrupo.placeholder.NomeDoGrupo} value={this.state.name_to_group} onChange={this.handleChange.bind(this, 'name_to_group')} />
          </div>
          <div className="form-group">
            <label>{this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formularioAdicionarNovoGrupo.MesesAnteriores}:</label>
            <InputMask required value={this.state.validate_month_time}  maskChar={null} name="validate_month_time" mask="999" className="form-control" onChange={this.handleChange.bind(this, 'validate_month_time')} placeholder={this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formularioAdicionarNovoGrupo.placeholder.InformarEmMesesDefasagemDoTreinamentoOcertificadoPodeTer} />
          </div>
          <div className="form-group">
            <label>{this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formularioAdicionarNovoGrupo.Tipo}:</label>
            <Select
              className="form-field-name"
              name="type_to_group"
              value={this.state.type_to_group}
              searchable={true}
              placeholder={this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formularioAdicionarNovoGrupo.placeholder.SelecionarTipo}
              onChange={this.handleSelectChange.bind(this, 'type_to_group')}
              options={this.state.types_list}
            />
          </div>
          <div className="form-group">
            <label>{this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formularioAdicionarNovoGrupo.Aplicabilidade}:</label>
            <Select
              className="form-field-name"
              name="type_applicability"
              value={this.state.type_applicability}
              searchable={true}
              placeholder={this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formularioAdicionarNovoGrupo.placeholder.SelecionarTipo}
              onChange={this.handleSelectChange.bind(this, 'type_applicability')}
              options={this.state.types_applicability}
            />
          </div>
          <div className="form-group">
            <label>{this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formularioAdicionarNovoGrupo.Certificados}:</label>
            <Select
              className="form-field-name"
              name="certification_id_to_group"
              value={this.state.certification_id_to_group}
              searchable={true}
              multi={true}
              placeholder={this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formularioAdicionarNovoGrupo.placeholder.SelecionarTipo}
              onChange={this.handleSelectChangeMulti.bind(this, 'certification_id_to_group')}
              options={this.state.certifications_list}
            />
          </div>
          <div className="form-group">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.formularioAdicionarNovoGrupo.botaoSalvarGrupo}</button>
          </div>
        </form>
      </div>
    </div>
    <h4>{this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.gruposDeCertificado}</h4>
    <hr/>
    {(this.state.certification_groups === null || typeof this.state.certification_groups === 'undefined') ?  '' : 
      Object.keys(self.state.certification_groups).map(function(k) {
        return (
          <CertificationGroupsCard handleAlert={self.props.handleAlert} refreshTable={self.props.refreshTable} certifications={self.state.certification_groups[k].certifications} certification_group_id={self.state.certification_groups[k].group_id} certification_group_name={self.state.certification_groups[k].group_name} validate_month_time={self.state.certification_groups[k].validate_month_time} applicability={self.state.certification_groups[k].applicability} group_type={self.state.certification_groups[k].group_type} certifications_list={self.state.certifications_list} types_applicability={self.state.types_applicability} deleteCertificationGroup={self.deleteCertificationGroup} RequestApi={self.refs.request_api} />
        );
      })
    }
  </div>
</div>
    );
  }
}

export default CertificationsEditTab;



// WEBPACK FOOTER //
// ./src/Components/Certifications/Elements/CertificationsEditTab.js